// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3B0r0","notes":"Notes_notes__1MZDq","note":"Notes_note__1GDla","markdown":"Notes_markdown__N4IXI"};